'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconConversation = function IconConversation(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M3.18606985,9.78145962 L3.18606985,17.1905792 L4.81312726,17.1905792 C5.27679647,17.1905792 5.65616218,17.5720557 5.65616218,18.0383046 L5.65616218,19.4624832 L8.2948615,17.3686016 C8.43817744,17.24992 8.62364512,17.1905792 8.81754316,17.1905792 L14.1455239,17.1905792 L14.1455239,9.78145962 L3.18606985,9.78145962 Z M8.16840626,8.0860089 L8.16840626,3.63545077 C8.16840626,2.70295288 8.9271377,1.94000006 9.85447611,1.94000006 L20.8139301,1.94000006 C21.7412686,1.94000006 22.5,2.70295288 22.5,3.63545077 L22.5,11.0445704 C22.5,11.9770683 21.7412686,12.7400211 20.8139301,12.7400211 L20.0299077,12.7400211 L20.0299077,15.0712659 C20.0299077,15.3934015 19.84444,15.6901054 19.5493778,15.8342187 C19.4313529,15.8850822 19.3048976,15.9189912 19.1868727,15.9189912 C19.0014051,15.9189912 18.807507,15.8511732 18.6557607,15.7324916 L15.8315937,13.4857512 L15.8315937,17.1905792 C15.8315937,18.1230771 15.0728623,18.88603 14.1455239,18.88603 L9.10417503,18.88603 L5.33580891,21.8785005 C5.18406263,21.997182 4.99859494,22.0650001 4.81312726,22.0650001 C4.68667202,22.0650001 4.56021678,22.031091 4.45062224,21.9802275 C4.15556002,21.8361142 3.97009233,21.5394103 3.97009233,21.2172747 L3.97009233,18.88603 L3.18606985,18.88603 C2.25030108,18.88603 1.5,18.1230771 1.5,17.1905792 L1.5,9.78145962 C1.5,8.84896173 2.25030108,8.0860089 3.18606985,8.0860089 L8.16840626,8.0860089 Z M9.85447611,8.0860089 L14.1455239,8.0860089 C15.0728623,8.0860089 15.8315937,8.84896173 15.8315937,9.78145962 L15.8315937,11.3229385 L18.3438378,13.3164744 L18.3438378,11.8922958 C18.3438378,11.4260468 18.7147732,11.0445704 19.1868727,11.0445704 L20.8139301,11.0445704 L20.8139301,3.63545077 L9.85447611,3.63545077 L9.85447611,8.0860089 Z' }),
      ' '
    )
  );
};

IconConversation.propTypes = {
  color: _propTypes2.default.string
};

IconConversation.defaultProps = {
  color: _colors2.default.icons
};

IconConversation.displayName = 'IconConversation';

exports.default = IconConversation;
module.exports = exports.default;